import styles from "./square.module.css"

export default function Square672() {
  return <div className={styles.square672}></div>
}
